import { NewsContentType } from '@/types/enum';
import image1 from '@/assets/images/news/hot/hot8.jpg';

export default {
  id: '20221108', //  模块 id
  title: '进博会助力叮咚买菜打造全球直采供应链 新西兰鹿肉直供中国餐桌', // 标题
  origin: '2022-11-08 16:06:11  来源：消费日报网', // 新闻来源
  editor: '作者：周健', // 编辑者
  content: [
    {
      type: NewsContentType.Text,
      isIndent: true,
      text:
        '11月8日，进博会上，叮咚买菜与来自新西兰的银蕨农场签署战略协议，将从新西兰牧场直采草饲鹿肉、小公牛等优质红肉，直供中国消费者的餐桌，此次合作金额达5000万人民币。',
    },
    {
      type: 1,
      title: '',
      src: [image1],
    },
    {
      type: NewsContentType.Text,
      isIndent: true,
      text:
        '叮咚买菜“买手团”已连续5年参加进博会，与众多国外优质农产品产区牵手合作，为中国消费者的餐桌引入全球最具“品价比”的美食好物。一进入会场，叮咚买菜“买手团”就开启了“买买买”模式，购物车率先加购的是红肉领域的新贵——新西兰草饲鹿肉。        ',
    }, 
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      isIndent: true,
      text:
        '相比猪、牛、羊等红肉，鹿肉在中国消费市场并不常见，但对很多外国人来说，鹿肉属于优质高端的蛋白质来源。在法国餐厅，以麋鹿做的主菜价钱不菲，在盛大的节日，除了火鸡外，如果还有一盆香气腾腾的烤鹿肉，那就是最好的礼遇了。        ',
    }, 
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      isIndent: true,
      text:
        '鹿肉的营养价值特别高，天然低脂，含铁量高，富含维生素B和锌、硒等各种微量元素。在传统上，鹿肉属于温热类的，非常滋补。特别适合秋冬季节用来进补。',
    }, 
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      isIndent: true,
      text:
        '其实，中国自古以来也有食用鹿肉的历史，周朝记录礼法的古籍上，便记录着很多鹿肉的做法；在《红楼梦》里有一个章节“琉璃世界白雪红梅，脂粉香娃割腥啖膻”，其中就有宝玉、黛玉与湘云在下雪天吃烤鹿肉的场景。        ',
    }, 
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      isIndent: true,
      text:
        '“旧时王谢堂前燕，飞入寻常百姓家。”自古以来只有达官显贵能够享用到的鹿肉，如今通过全球供应链，也变成了消费者日常商品中唾手可得的一部分。',
    }, 
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      isIndent: true,
      text:
        '很多新的商品进入市场时，总会担心销量不好。为了帮助新品打开市场，叮咚买菜会通过场景打造、新品首发、专属频道、主题促销等给到合作商毫无保留的支持。比如在鹿肉的推广上，针对养生人群，专门打造了秋冬养生场景，主打鹿肉的滋补特性；针对健身人群，打造了轻食场景，突出鹿肉的天然、健康、低脂高蛋白等特性。',
    }, 
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      isIndent: true,
      text:
        '此外，叮咚买菜能够为供应商提供大数据支持，包括用户需求、消费偏好、销量预测、智能定价、缺货与损耗控制等，并将相关数据向供应商开放。通过技术导入、品质管控与升级，叮咚买菜联合供应商开发差异化新品，并将其打造为品牌推向市场。',
    }, 
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      isIndent: true,
      text:
        '此外，叮咚买菜能够为供应商提供大数据支持，包括用户需求、消费偏好、销量预测、智能定价、缺货与损耗控制等，并将相关数据向供应商开放。通过技术导入、品质管控与升级，叮咚买菜联合供应商开发差异化新品，并将其打造为品牌推向市场。',
    }, 
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      isIndent: true,
      text:
        '叮咚买菜高级副总裁徐志坚表示，“作为一家长期聚焦生鲜食品的供应链公司，我们在不断夯实国内供应链的同时，也在加速打造全球直采供应链，打造高‘品价比’、有特色、有场景的商品力。我们组建了专业的海外直采团队，在泰国、东南亚、澳大利亚、美国、加拿大、巴西、乌拉圭、阿根廷、智利、南非等地区均建立了海外直采基地，我们希望与更多像‘银蕨农场’这样的合作伙伴相互赋能，最终建立全球化的产销健康协同、中间无博弈、共赋能的端到端生态供应链。用更多美好的商品，来不断满足消费者对更加美好生活的追求。”',
    }, 
  ],
};
